// ----------------------------------------------------------------------
// <copyright file="Izenda.SecurityPoliciesConstant.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import localizer from 'share/localization/Izenda.Localizer';
import { toNumber } from 'lodash/fp';
const REQUIRED_MIN_VALUE = 0;

export default {
  REQUIRED_MIN_VALUE: 0,
  REQUIRED_MIN_POSITIVE_VALUE: 1,
  REQUIRED_VALUE_NO_PASSWORD_KEEP: 5,
  REQUIRED_VALUE_NO_SECURITY_QUESTIONS: 18,
  PASSWORD_VALIDITY: {
    get MIN_PASSWORD_AGE() {
      return localizer.getText('SECURITY_POLICIES_CONSTANT_MIN_PASSWORD_AGE');
    },
    get MAX_PASSWORD_AGE() {
      return localizer.getText('SECURITY_POLICIES_CONSTANT_MAX_PASSWORD_AGE');
    }
  },
  SECURITY_QUESTION_FIELD_NAME: {
    get USER_PROFILE() {
      return localizer.getText('SECURITY_POLICIES_CONSTANT_USER_PROFILE');
    },
    get RESET_PASSWORD() {
      return localizer.getText('SECURITY_POLICIES_CONSTANT_RESET_PASSWORD');
    }
  },
  get SECURITY_QUESTIONS() {
    return localizer.getText('SECURITY_POLICIES_CONSTANT_SECURITY_QUESTIONS');
  },
  numberLimitConstraints(isMinField, fieldNameMinValue, fieldNameMaxValue, minValue, maxValue, sumAllValue) {
    let requireConstraint;

    // convert to number
    minValue = toNumber(minValue);
    maxValue = toNumber(maxValue);

    // check the relationship business constraints between min & max values
    if (minValue < maxValue && sumAllValue) {
      let greaterThanOrEqualTo;
      if (isMinField) {
        greaterThanOrEqualTo = minValue < sumAllValue ? sumAllValue : null;
      } else {
        greaterThanOrEqualTo = maxValue < sumAllValue ? sumAllValue : null;
      }
      requireConstraint = {
        presence: {
          presence: true,
          message: String.format(
            localizer.getText('COMMON_MESSAGES_REQUIRED'),
            isMinField ? fieldNameMinValue : fieldNameMaxValue
          )
        },
        numericality: {
          onlyInteger: true,
          greaterThanOrEqualTo,
          get notGreaterThanOrEqualTo() {
            return isMinField
              ? localizer.getText('SECURITY_POLICIES_CONSTANT_ERROR_MIN_VALUE')
              : localizer.getText('SECURITY_POLICIES_CONSTANT_ERROR_MAX_VALUE');
          }
        }
      };
    } else {
      const errorCompareValueMessage = String.format(
        localizer.getText('SECURITY_POLICIES_CONSTANT_MUST_BE_SMALLER_THAN'),
        fieldNameMinValue,
        fieldNameMaxValue
      );
      requireConstraint = {
        presence: {
          presence: true,
          message: String.format(
            localizer.getText('COMMON_MESSAGES_REQUIRED'),
            isMinField ? fieldNameMinValue : fieldNameMaxValue
          )
        },
        numericality: {
          onlyInteger: true,
          lessThan: isMinField ? maxValue : null,
          greaterThan: !isMinField ? minValue : null,
          notLessThan: isMinField ? errorCompareValueMessage : null,
          notGreaterThan: !isMinField ? errorCompareValueMessage : null
        }
      };
    }

    return requireConstraint;
  },
  requiredConstraints(fieldName) {
    return {
      presence: {
        presence: true,
        message: String.format(localizer.getText('COMMON_MESSAGES_REQUIRED'), fieldName)
      },
      numericality: {
        onlyInteger: true
      }
    };
  },
  securityQuestionConstraint(isMinField, fieldNameMinValue, fieldNameMaxValue, minValue, maxValue) {
    const errorMessage = localizer.getText('SECURITY_POLICIES_CONSTANT_MESSAGE_ERROR_SECURITY_QUESTION_RESET_PASSWORD');
    // convert to number
    minValue = toNumber(minValue);
    maxValue = toNumber(maxValue);
    if (maxValue === REQUIRED_MIN_VALUE) {
      return null;
    }
    const constraints = {
      presence: {
        presence: true,
        message: String.format(
          localizer.getText('COMMON_MESSAGES_REQUIRED'),
          isMinField ? fieldNameMinValue : fieldNameMaxValue
        )
      },
      numericality: {
        onlyInteger: true,
        lessThanOrEqualTo: isMinField ? maxValue : null,
        greaterThanOrEqualTo: !isMinField ? minValue : null,
        notLessThanOrEqualTo: errorMessage,
        notGreaterThanOrEqualTo: errorMessage
      }
    };

    return constraints;
  }
};



// WEBPACK FOOTER //
// ./ui/logic/data/Izenda.SecurityPoliciesConstant.js